<template>
  <div class="mb-4">
    <p class="font-weight-bolder">{{ title }}</p>
    <b-row>
      <b-col cols="5">
        <div class="container-options">
          <div
            v-for="(option, index) in currentOptions"
            :key="index"
            class="option"
            :class="{ 'option-active-left': selectedLeft.includes(option) }"
            @click="handleSelectLeft(option)"
          >
            <p class="mb-0">{{ option.label }}</p>
          </div>
        </div>
      </b-col>

      <b-col cols="2" class="d-flex flex-column p-0" style="gap: 8px">
        <b-button
          size="sm"
          class="w-100"
          variant="outline"
          @click="toggleMove"
          :disabled="disabled"
        >
          <feather-icon icon="RepeatIcon" size="16" />
        </b-button>
        <b-button
          size="sm"
          class="w-100"
          variant="outline-secondary"
          @click="selectAll"
          :disabled="disabled"
          >Select All</b-button
        >
        <b-button
          size="sm"
          class="w-100"
          variant="outline-secondary"
          @click="unselectAll"
          :disabled="disabled"
          >Unselect All</b-button
        >
      </b-col>

      <b-col cols="5">
        <div class="container-options">
          <div
            v-for="(option, index) in selectedRight"
            :key="index"
            class="option"
            :class="{
              'option-active-left': selectedRightActive.includes(option),
            }"
            @click="handleSelectRight(option)"
          >
            <p class="mb-0">{{ option.label }}</p>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BButton, BCol, BRow } from "bootstrap-vue";
import { arrayProp, stringProp, booleanProp } from "@/helpers/props";

export default {
  props: {
    title: stringProp(),
    options: arrayProp(),
    listSelected: arrayProp([]),
    disabled: booleanProp(false),
  },
  components: {
    BButton,
    BCol,
    BRow,
  },
  watch: {
    options(val) {
      this.currentOptions = val;
    },
    selectedRight(list) {
      if (list.length) {
        this.currentOptions = this.options.filter(
          (i) => !list.some((j) => j.value === i.value)
        );
      } else {
        this.currentOptions = this.options;
      }
      this.$emit("onSelectApplies", list);
    },
    listSelected() {
      this.handleLoad();
    },
  },
  data() {
    return {
      currentOptions: this.options,
      selectedLeft: [],
      selectedRight: [],
      selectedRightActive: [],
    };
  },
  mounted() {
    this.handleLoad();
  },
  methods: {
    handleLoad() {
      if (this.listSelected.length) {
        this.selectedRight = this.currentOptions.filter((i) =>
          this.listSelected.some((j) => j.value === i.value)
        );
        this.currentOptions = this.options.filter(
          (i) => !this.listSelected.some((j) => j.value === i.value)
        );
      }
    },
    selectAll() {
      if (this.disabled) return;
      this.selectedRight = [...this.options];
    },
    unselectAll() {
      if (this.disabled) return;
      this.selectedRight = [];
    },
    handleSelectLeft(option) {
      if (this.disabled) return;
      const isExist = this.selectedLeft.some((i) => i.value === option.value);
      if (isExist) {
        this.selectedLeft = this.selectedLeft.filter(
          (i) => i.value !== option.value
        );
      } else {
        this.selectedLeft.push(option);
      }
    },
    handleSelectRight(option) {
      if (this.disabled) return;
      const isExist = this.selectedRightActive.some(
        (i) => i.value === option.value
      );
      if (isExist) {
        this.selectedRightActive = this.selectedRightActive.filter(
          (i) => i.value !== option.value
        );
      } else {
        this.selectedRightActive.push(option);
      }
    },
    toggleMove() {
      if (this.disabled) return;
      if (this.selectedLeft.length) {
        const toMove = this.selectedLeft.filter(
          (i) => !this.selectedRight.some((j) => j.value === i.value)
        );
        this.selectedRight.push(...toMove);
        this.selectedLeft = [];
      } else if (this.selectedRightActive.length) {
        this.currentOptions.push(...this.selectedRightActive);
        this.selectedRight = this.selectedRight.filter(
          (i) => !this.selectedRightActive.some((j) => j.value === i.value)
        );
        this.selectedRightActive = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  height: 220px;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.option {
  background: white;
  cursor: pointer;
  padding: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  &-active {
    &-left {
      background: #b6d4fe;
      border-color: #0d6efd;
      p {
        color: #0d6efd;
      }
    }
  }
}
</style>
